exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LessonCard-module__top___3SpYE{display:grid;grid-template-columns:1fr auto auto;gap:.75rem;align-items:center;margin-right:1rem}.LessonCard-module__bar___5Tbrb{width:100%;height:2px;background-color:#ececec;margin:1.5rem 0}.LessonCard-module__add-content___240el{text-align:center;color:#b4bac3;font-size:14px;margin-bottom:1rem}.LessonCard-module__content___32abD{display:grid;gap:1rem;margin-bottom:1rem}.LessonCard-module__button-wrapper___2GYZ4{display:grid;grid-auto-flow:column;justify-content:center;gap:1rem}.LessonCard-module__button-wrapper___2GYZ4 button{width:100px}", ""]);

// exports
exports.locals = {
	"top": "LessonCard-module__top___3SpYE",
	"bar": "LessonCard-module__bar___5Tbrb",
	"add-content": "LessonCard-module__add-content___240el",
	"content": "LessonCard-module__content___32abD",
	"button-wrapper": "LessonCard-module__button-wrapper___2GYZ4"
};